module.exports = __webpack_public_path__ + "static/img/ROMANA-OAK.cfd40fc.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/ROMANA-OAK.png
// module id = FOsJ
// module chunks = 0